var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"cooperation",attrs:{"id":"cooperate"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item,"alt":"","id":index===0?'business':''}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }